import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	DateFrom: null as Date | null,
	DateTo: null as Date | null,
	WorkshopIds: [1] as number[],
	LoggedUserId: null as number | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WorkshopId: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {
	},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
